import React, { useEffect, useMemo, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import { Card, CardBody, Col } from "reactstrap";
import { toast } from "react-toastify";
import { H2 } from "../../../AbstractElements";
import Favourite from "../../../Components/Widgets/Favourite";
import { formatDateIT } from "../../../Helpers";
import { getRapportini } from "../../../Features/report/api/report.api";
import type { RapportinoListItem } from "../../../Features/report/api/type";

function fmtDate(value?: string | null, withTime = false): string {
  if (!value) return "-";
  return formatDateIT(value, false) || "-";
}

function fmtOre(value?: number): string {
  if (value === undefined) return "-";
  return `${value} h`;
}

export default function ListaRapportini() {
  const [rows, setRows] = useState<RapportinoListItem[]>([]);
  const [loading, setLoading] = useState(false);

  async function loadRapportini() {
    setLoading(true);
    try {
      const list = await getRapportini();
      // const sorted = list.sort((a, b) =>
      //   (a.ragioneSociale ?? "").localeCompare(b.ragioneSociale ?? "")
      // );
      setRows(list);
    } catch (err) {
      console.error(err);
      toast.error("Errore nel caricamento dei rapportini");
      setRows([]);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadRapportini();
  }, []);

  const columns: TableColumn<RapportinoListItem>[] = useMemo(
    () => [
      {
        name: "ID Rapportino",
        selector: r => r.id ?? "",
        sortable: true,
        width: '10%',
        grow: 1,
        cell: r => r.id || "-",
      },
      {
        name: "Ragione sociale",
        selector: r => r.ragioneSociale ?? "",
        sortable: true,
        width: '30%',
        grow: 1,
        cell: r => r.ragioneSociale || "-",
      },
      {
        name: "Ore cliente",
        selector: r => r.oreCliente ?? 0,
        sortable: true,
        width: "10%",
        right: true,
        cell: r => fmtOre(r.oreCliente),
      },
      {
        name: "Ore factory",
        selector: r => r.oreFactory ?? 0,
        sortable: true,
        width: "10%",
        right: true,
        cell: r => fmtOre(r.oreFactory),
      },
      {
        name: "Data inizio",
        selector: r => r.dataInizio ?? "",
        sortable: true,
        width: "10%",
        cell: r => fmtDate(r.dataInizio),
      },
      {
        name: "Data fine",
        selector: r => r.dataFine ?? "",
        sortable: true,
        width: "10%",
        cell: r => fmtDate(r.dataFine),
      },
      {
        name: "Creato il",
        selector: r => r.dataIns ?? "",
        sortable: true,
        width: "10%",
        cell: r => fmtDate(r.dataIns, true),
      },
      {
        name: "File",
        selector: r => r.path ?? "",
        width: "10%",
        center: true,
        cell: r =>
          r.path ? (
            <a href={r.path} target="_blank" rel="noreferrer" title="Apri rapportino">
              <i className="fa-solid fa-file-arrow-up" />
            </a>
          ) : (
            "-"
          ),
      },
    ],
    []
  );

  return (
    <div className="page-body pt-4">
      <Card>
        <CardBody>
          <Col xl={12} className="mb-lg-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
              <H2 className="mb-0">Lista Rapportini</H2>
              <Favourite percorso={"/report/rapportini"} nome={"Lista Rapportini"} />
            </div>
          </Col>
        </CardBody>
      </Card>

      <Col xl={12}>
        <Card>
          <CardBody>
            <div className="table-responsive">
              <DataTable
                columns={columns}
                data={rows}
                progressPending={loading}
                striped
                highlightOnHover
                dense
                pagination
                noDataComponent="Nessun rapportino disponibile"
              />
            </div>
          </CardBody>
        </Card>
      </Col>
    </div>
  );
}
